<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">

				<el-form-item>
					<el-date-picker type="date" placeholder="奖励开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
						-
					<el-date-picker type="date" placeholder="奖励结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
					<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
						:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<span>奖励总金额：{{stockTable.all_money}} 元</span>
			</div>
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
			
				<el-table-column header-align="center" align="center" prop="date" label="奖励时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="all_money" label="当日共计奖励(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="profit_money" label="分润金额(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="flow_money" label="流量卡分成(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="zero_withdraw_money" label="分润账户提现税点分成(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="one_withdraw_money" label="达标返现提现税点分成(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="two_withdraw_money" label="押金账户提现税点分成(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="reward_withdraw_money" label="奖励账户提现税点分成(元)"></el-table-column>
				<el-table-column header-align="center" align="center" prop="five_withdraw_money" label="特惠奖励账户提现税点分成(元)"></el-table-column>
                <el-table-column header-align="center" align="center" prop="six_withdraw_money" label="大盘分红账户提现税点分成(元)"></el-table-column>
                <el-table-column header-align="center" align="center" prop="seven_withdraw_money" label="管理奖账户提现税点分成(元)"></el-table-column>
                <el-table-column header-align="center" align="center" prop="eight_withdraw_money" label="底薪奖账户提现税点分成(元)"></el-table-column>
                <el-table-column header-align="center" align="center" prop="nine_withdraw_money" label="流量卡账户提现税点分成(元)"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		
	</div>
</template>

<script>
	import paginations from '../../components/pagination/paginations';
	export default {
		name: "rewardDetails",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					is_list:2,
					start_time:'',
					end_time:'',
				},
				stockTable: { //列表
					list: [],
					all_money:0,
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
				downLoading:false
			}
		},
		mounted() {
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				is_list:2
			})
		},
		components: {
			paginations,
		},
		methods: {
			handleDownLoad(params) { //导出
				let reqData = {
					type: 12,
					value: JSON.stringify(params)
				};
			
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.user_id = this.$route.query.user_id;
				queryForm.is_list = 2;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("userteamleader/getUserTeamRewardList", params, res => {
					let data = res.data;
					this.page.total = data.list.total; //总数
					this.stockTable.list = res.data.list.data;
					this.stockTable.all_money = res.data.all_money;
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>